import React from "react";
import "./Item.css";
import PopupClub from "shared/components/popups/PopupClub";
import { useIsSmall } from "shared/components/utils/UtilIsSmall.js";

interface ItemRowClubProps {
  c: object;
  overall?: Object;
  formation?: Object;
  isSelected: boolean;
  selectable: boolean;
  onSelect: func;
  trigger?: object;
  className?: String;
}

const ItemRowClub: React.FC<ItemRowClubProps> = ({
  c,
  overall,
  formation,
  isSelected,
  selectable,
  onSelect,
  trigger,
  className,
}) => {
  const { ref: containerRef, isSmall } = useIsSmall(400);
  
  return (
    <div ref={containerRef} className={"Item d-flex flex-row flex-fill " + (isSelected ? "selected " : " ")  + (className ? className : " ") }>
      {selectable && (
        <div className="d-flex me-1">
          <input type="checkbox" defaultChecked={isSelected} checked={isSelected} onChange={() => (onSelect ? onSelect(c) : undefined)} />
        </div>
      )}
      <PopupClub
        className="flex-fill"
        club={c}
        trigger={
          trigger ? (
            trigger
          ) : (
            <div className="flex-fill">
              <div className={`d-flex ${isSmall ? "flex-column" : "flex-row"} flex-fill pb-1 pb-md-0`}>
                <div className={`d-flex  ${isSmall ? "" : "flex-basis-300"}`}>
                  <i className="bi bi-buildings-fill me-1" />
                  {c.name ? c.name : "Non-established club"}
                </div>

                <div className="d-flex flex-grow-1">
                  <div className="d-flex flex-grow-1">
                    {c.country ? (
                      <img
                        className="d-inline me-1 my-1"
                        style={{ height: 14 }}
                        src={`https://app.playmfl.com/img/flags/${c.country}.svg`}
                      />
                    ) : (
                      ""
                    )}

                    {c.city ? c.city : "Unknown city"}
                  </div>

                  {overall && (
                    <div className="d-flex flex-basis-80">
                      <div style={{ opacity: ".2" }}>OVR:&nbsp;</div>
                      {overall}
                    </div>
                  )}
                  {formation && (
                    <div className="d-flex flex-basis-160">
                      <div style={{ opacity: ".2" }}>&nbsp;Form.:&nbsp;</div>
                      {formation}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )
        }
      />
    </div>
  );
};

export default ItemRowClub;
